import { fetchAllChallengeTags } from '@actions/challengeTags';
import { fetchAllBusinessTags } from '@actions/challengeTags/fetchAllBusinessTags';
import {
    getBusinessTags,
    getChallengeTags,
    getChallengeTagsFetchError,
    getChallengeTagsIsFetching,
} from '@selectors/challengeTags';
import { tagTypes } from 'lib/src/shared/enums/tagTypes';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const useFetchChallengeTags = (type: tagTypes) => {
    const dispatch = useDispatch();
    useEffect(() => {
        if (type === tagTypes.tag) {
            dispatch(fetchAllChallengeTags());
        } else {
            dispatch(fetchAllBusinessTags());
        }
    }, [dispatch, type]);

    const selector = type === tagTypes.tag ? getChallengeTags : getBusinessTags;
    const challengeTags = useSelector(selector);
    const isFetching = useSelector(getChallengeTagsIsFetching);
    const fetchError = useSelector(getChallengeTagsFetchError);

    return {
        challengeTags: Object.values(challengeTags),
        isFetching,
        fetchError,
    };
    // get tags, fetching, error from redux
};

export default useFetchChallengeTags;
